import { useState, useRef, useEffect } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getbyprojectno } from "../../Services/pqr-header-service";
import { PQRHeader } from "./PQRObjects/PQR_entity";
import { Action, Status, MessageTypes } from "../utility/common/constants/CommonConstants";
import PQRPage1 from "./PQR_Page1";
import PQRPage2 from "./PQR_Page2";
import { NavigationButtons } from "../utility/ui/navigation/TransactionNavigation/NavigationButtons";
import { showToast, executeChildFunction, handleNavigation } from "../utility/ui/navigation/TransactionNavigation/TransactionUtils";
import { getdetailsById } from "../../Services/pqr-details-service";
import {
  Tensile_Test_Obj, Other_Test_Obj, Certification_Obj
  , GuidedBend_Test_Obj, GuidedBend_Test_Overlay_Obj
  , Toughness_Test_Obj, createDetailObjPQR,
  CertificationLabRef_Obj
} from "./PQRObjects/PQR_common";
import { DisableFields } from "../WPSTransaction/WPSObjects/WPSCommonUtils";
import { normalstyle, bluestyle, errorstyle } from "../../functions/welding-functions";

const PQRGrooveTransaction = () => {
  const [key, setKey] = useState(1);
  const firstChildRef = useRef();
  const secondChildRef = useRef();
  const location = useLocation();
  let UserName = sessionStorage.getItem("UserName");
  let UserId = sessionStorage.getItem("UserId");
  const [copydata, setcopydata] = useState("");
  const [action,setaction] = useState(location.state?.action  || Action.ActionAdd);
  const [originalaction] = useState(location.state?.action || Action.ActionAdd);
  const [WPStype] = useState(location.state?.WPStype);
  const [headerloaded, setheaderloaded] = useState(false)
  const [headerObj, setheaderObj] = useState(
    action === Action.ActionEdit || action === Action.ActionCopy
      ? location.state?.data
      : PQRHeader(WPStype)
  );

  const [editheaderObj, seteditheaderObj] = useState(
    action === Action.ActionEdit || action === Action.ActionCopy
      ? location.state?.data
      : PQRHeader(WPStype)
  );
  const [isDisabled, setIsDisabled] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [detailObj, setdetailObj] = useState([]);
  const [prevdetailobj, setprevdetailObj] = useState([]);

  useEffect(() => {

    let read = DisableFields(headerObj.WPSH_Status, headerObj.WPSH_Prepared_By, Status, Action, action)
    
    setIsReadonly(read);
    setIsDisabled(read);

  }, [action]);

  const initializeTestObjects = () => {
    let Other_testCount = WPStype === "Overlay" ? 15 : 9;
    return {
      Tensile_Test: Tensile_Test_Obj(1, 8),
      GuidedBend_Test: GuidedBend_Test_Obj(1, 4),
      Toughness_Test: Toughness_Test_Obj(1, 12),
      Certification: Certification_Obj(1, 6),
      CertificationLabRef: CertificationLabRef_Obj(1, 4),
      Other_Test: Other_Test_Obj(1, Other_testCount),
      GuidedBend_Test_Overlay: GuidedBend_Test_Overlay_Obj(1, 8),
    }
  }

  useEffect(() => {
    let temparray = []
    if (action === Action.ActionAdd) {
      let Certification;
      let CertificationLabRef;
      temparray = createDetailObjPQR(1, WPStype === "Overlay" ? 2 : 4);
      const { Tensile_Test, GuidedBend_Test, Toughness_Test, Other_Test, GuidedBend_Test_Overlay } = initializeTestObjects();
      setdetailObj(temparray);
      setheaderObj({
        ...headerObj,
        Tensile_Test,
        GuidedBend_Test,
        Toughness_Test,
        Other_Test,
        // Other_Test_overlay,
        CertificationLabRef,
        Certification,
        GuidedBend_Test_Overlay,
      });
    }
    else {
      let IdprojectPK = location.state?.data.PK;
      let IdprojectSK = location.state?.data.PQR_RecordNo;
      fetchprojectbyid(IdprojectPK, IdprojectSK);
      fetchbyid(IdprojectPK, IdprojectSK, location.state?.data.WPSH_PQR_Process);
    }
  }, []);

  const getTestObject = (testName, defaultObj) => {
    if (editheaderObj[testName] === undefined) return defaultObj;
    const existing = headerObj[testName] || [];
    if (existing.length >= defaultObj.length) return existing;
    const template = defaultObj[0];
    const empty = Object.fromEntries(Object.keys(template).map(k => [k, ""]));
    return [...existing, ...Array(defaultObj.length - existing.length).fill(null).map(() => ({ ...empty }))];
  };


  useEffect(() => {
    const testObjects = initializeTestObjects();
    Object.keys(testObjects).forEach(key => {
      editheaderObj[key] = getTestObject(key, testObjects[key]);
    });
    console.log("initializeEditMode", headerObj)
    setheaderObj(editheaderObj);
  }, [headerloaded])
//   useEffect(() => {
//   const testObjects = initializeTestObjects();
//   Object.keys(testObjects).forEach(k => {
//     if (k === 'Other_Test' && editheaderObj[k] !== undefined) {
//       const existing = headerObj[k] || [];
//       const needed = 15;
//       if (existing.length < needed) {
//         const extra = Other_Test_Obj(1, needed - existing.length);
//         editheaderObj[k] = [...existing, ...extra];
//       } else {
//         editheaderObj[k] = existing;
//       }
//     } else {
//       editheaderObj[k] = getTestObject(k, testObjects[k]);
//     }
//   });
//   setheaderObj({ ...editheaderObj });
// }, [headerloaded]);


  function CreatePreviousProcess(detail) {
    let oldval = []
    detail?.forEach(process => {
      let prc = { Process: process.PQR_Process, Type: process.PQR_Type }
      oldval.push(prc)
    })
    setprevdetailObj(oldval)
  }

  const [logObj, setlogObj] = useState({
    WPSH_Project_No_log:
      headerObj !== undefined ? headerObj.WPSH_Project_No : "",
    WPSH_WPS_No_log: headerObj !== undefined ? headerObj.WPSH_WPS_No : "",
    WPSH_User_Name_log: UserName,
    WPSH_User_Id_log: UserId,
    WPSH_Status_log: "",
  });

  const fetchprojectbyid = async (IdprojectPK, IdprojectSK) => {
    let reqParam = {
      groovetype: WPStype,
      pkid: IdprojectPK,
      skid: IdprojectSK,
    };
    const result = await getbyprojectno(reqParam);
    if (result !== undefined && result[0] !== undefined) {
      seteditheaderObj(result[0]);
      setheaderObj(result[0]);
      setheaderloaded(true)
    }
  };

  const fetchbyid = async (IddetailPK, IddetailSK, processOrder) => {
    let reqDetailParam = {
      id1: WPStype,
      id2: IddetailSK,
    };
    const result = await getdetailsById(reqDetailParam);
    let temparray1 = [];

    if (action !== Action.ActionAdd) {
      let sorted = result;
      if (processOrder) {
        const orderList = processOrder.split(",").filter(Boolean);
        sorted = orderList
          .map(process => result.find(item => item.PQR_Process === process))
          .filter(Boolean);
      }

      let len = sorted.length;
      let loop = 5 - len;
      if (loop > 0) {
        temparray1 = createDetailObjPQR(len + 1, WPStype === "Overlay" ? 2 : 4);
        setdetailObj([...sorted, ...temparray1]);
        temparray1 = [...sorted, ...temparray1];
      } else {
        temparray1 = sorted;
        setdetailObj([...sorted]);
      }
    }
    CreatePreviousProcess(temparray1);
  };

  useEffect(() => {
    if (action === Action.ActionCopy) {
      setcopydata(true);
    }
  }, []);

  const next = async (e) => {
    const refs = [firstChildRef, secondChildRef];
    const funcNames = ['funcOnNext', 'funcOnNext2'];
    const funcName = funcNames[key - 1];
    const res = await executeChildFunction(refs, key, funcName);
    showToast(res, key, setKey, 2, true);
  };

  const handleSelect = (e) => {
    Temp(e, "tab");
  };

  const Temp = async (e, tabaction) => {
    const refs = [firstChildRef, secondChildRef];
    const funcNames = ['funcOnNextTemp', 'funcOnNextTemp2'];
    const funcName = funcNames[key - 1];
    const res = await executeChildFunction(refs, key, funcName);
    showToast(res, key, setKey, 2, true);
    if (res === MessageTypes.Temp || res === MessageTypes.None) {
      handleNavigation(tabaction, e, key, setKey, 2);
    }
  };

  return (
    <>
      <div className="position-absolute ms-3" style={{ top: "15px" }}>
        <strong>Add New</strong>
      </div>
      <div className="border-divider" />
      <div className="mt-4">
        <div style={{ borderBottom: "2px solid var(--col-ddd)", position: "relative", top: "34px", zIndex: "-2" }}></div>
        <Tabs
          activeKey={key}
          onSelect={(e) => handleSelect(e)}
          className="mb-2 w-100 border-end"
          fill
        >
          <Tab
            eventKey={1}
            title={WPStype === "Groove" ? ("PQR-Page 1 (Weld Groove)") : ("PQR-Page 1 (Weld Overlay)")}
            style={{
              height: window.innerHeight - 180,
              overflowY: "auto",
              overflowX: "hidden",
              width: window.innerWidth - 50
            }}
          >
            <PQRPage1
              ref={firstChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              createDetailObjPQR={createDetailObjPQR}
              detailObj={detailObj}
              prevdetailobj={prevdetailobj}
              setprevdetailObj={setprevdetailObj}
              setdetailObj={setdetailObj}
              normalstyle={normalstyle}
              errorstyle={errorstyle}
              bluestyle={bluestyle}
              WPStype={WPStype}
              setKey={setKey}
              tabno={key}
              isDisabled={isDisabled}
              isReadonly={isReadonly}
              setaction={setaction}
              action={action}
              setIsDisabled={setIsDisabled}
            />
          </Tab>
          <Tab
            eventKey={2}
            title="PQR-Page 2"
            style={{
              height: window.innerHeight - 180,
              overflowY: "auto",
              overflowX: "hidden",
            }}
            disabled={action === Action.ActionAdd}
          >
            <PQRPage2
              ref={secondChildRef}
              headerObj={headerObj}
              setheaderObj={setheaderObj}
              detailObj={detailObj}
              setdetailObj={setdetailObj}
              copydata={copydata}
              WPStype={WPStype}
              logObj={logObj}
              setKey={setKey}
              tabno={key}
              setlogObj={setlogObj}
              isDisabled={isDisabled}
              isReadonly={isReadonly}
              setIsReadonly={setIsReadonly}
              setaction={setaction}
              action={action}
            />
          </Tab>
        </Tabs>
        <NavigationButtons
          currentKey={key}
          maxTabs={2}
          isBtnDisabled={isDisabled ? "disabled" : ""}
          originalAction={originalaction}
          onNext={next}
          onTemp={Temp}
        />
      </div>
    </>
  );
};

export default PQRGrooveTransaction;